var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiSelectConvDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160719",
    "data-name": "Group 160719",
    transform: "translate(-279 -136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160714",
    "data-name": "Group 160714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1961",
    "data-name": "Rectangle 1961",
    transform: "translate(282 139)",
    fill: "#141414",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 11.5,
    height: 11.5,
    rx: 3.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1962",
    "data-name": "Rectangle 1962",
    transform: "translate(279 136)",
    fill: "#141414",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 11.5,
    height: 11.5,
    rx: 3.25,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiSelectConvDark);
export default __webpack_public_path__ + "static/media/MultiSelectConvDark.6c791c716cfd6a292c72efae7f068484.svg";
export { ForwardRef as ReactComponent };